import { render, staticRenderFns } from "./InfoButton.vue?vue&type=template&id=c33116a8&scoped=true&lang=pug"
import script from "./InfoButton.vue?vue&type=script&lang=ts"
export * from "./InfoButton.vue?vue&type=script&lang=ts"
import style0 from "./InfoButton.vue?vue&type=style&index=0&id=c33116a8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33116a8",
  null
  
)

export default component.exports